module.exports = __webpack_public_path__ + "img/zhubaowenwan.eea82ef2.png";